import '../../blocks/modals/modals';
import '../../blocks/modals/modal-phone/modal-phone';

import '../js/functions/helpers';
import '../js/functions/utm_link';
